import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { URL } from "./apiurl";

export const handleLogin = createAsyncThunk("signUpApi", async (payload) => {
  const response = await axios.post(URL.LOGIN, {
    Mobile: "",
    PassWord: payload?.password,
    UserName: payload?.userId,
  });
  return response.data;
});

const initialState = {
  error: false,
  loading: false,
  success: false,
};

export const signupSlice = createSlice({
  name: "LoginClick",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(handleLogin.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(handleLogin.fulfilled, (state, action) => {
        state.loading = false;
        const { payload } = action;

        if (payload) {
          window.localStorage.setItem("user-Access", payload?.token);
          window.localStorage.setItem("CompanyID", payload?.user[0]?.CompanyID);
          window.localStorage.setItem("user-Id", payload?.user[0]?.EmployeeID);
          window.localStorage.setItem(
            "isSkipLoginImage",
            payload?.user[0]?.isSkipLoginImage
          );
          window.location.reload();
        }
      })
      .addCase(handleLogin.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

// this is for dispatch
export const { LoginClick } = signupSlice.actions;

// this is for configureStore
export default signupSlice.reducer;
